import * as defaultImport from "@splunk/react-icons/enterprise/GaugeMarker";
export * from "@splunk/react-icons/enterprise/GaugeMarker";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
